import React, { FC } from 'react';

import { Svg, useSvgColor } from '~/assets/icons/styles';
import { OneColorIconProps } from '~/assets/icons/types';

const ReorderIcon: FC<OneColorIconProps> = ({ color, ...props }) => {
  const svgColor = useSvgColor(color);

  return (
    <Svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      svgColor={svgColor}
    >
      <path
        d="M1.33337 5.33398H14.6667"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.33337 10.666H14.6667"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Svg>
  );
};

export default ReorderIcon;
